module.exports = __webpack_public_path__ + "img/34.4.NH3-N.19f3e462.png";